import i18n from "../i18n";
import { startCase } from "lodash";
import { AuthUserInfo, IsLockScreen } from "../constants";
import LocalstorageService from "./localstorage-service";

function isMobileDevice() {
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}

function updateAppTitle(pathname) {
  window.scrollTo(0, 0);
  const currentPage = startCase(pathname).replaceAll("-", " ");
  document.title = `${currentPage} | ${process.env.REACT_APP_APPLICATION_TITLE}`;
}

function validateEmail(email = "") {
  return !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email);
}

function changeAppLanguage(lang = "en") {
  i18n.changeLanguage(lang);
  window.location.reload();
}

function checkAuthToken() {
  const authInfo = LocalstorageService.getItem(AuthUserInfo);
  return !!authInfo?.token;
}

// Prevent non-english characters.
function isValidPasswordChar(value) {
  return /^[A-Za-z\d#$@!%&*?]*$/.test(value.toString());
}

function removeAuthUserInfo() {
  LocalstorageService.removeItem(AuthUserInfo);
  LocalstorageService.removeItem(IsLockScreen);
}

function numberFormatter(value, decimalScale = 0) {
  if (!value && value !== 0) return value;

  const isNegative = Number(value) < 0;
  const absValue = Math.abs(Number(value));

  const parts = absValue.toString().split(".");
  const numberPart = parts[0];
  let decimalPart = parts[1] || "";

  if (decimalScale !== 0) {
    decimalPart = decimalPart.padEnd(decimalScale, 0);
  }

  const thousands = /\B(?=(\d{3})+(?!\d))/g;

  let formattedValue =
    numberPart.replace(thousands, ",") + (decimalPart ? "." + decimalPart : "");

  // Add LRM (Left-to-Right Mark) before minus sign for correct RTL display
  if (isNegative) {
    formattedValue = "\u200E-" + formattedValue;
  }

  return formattedValue;
}

// Format number with LRM for RTL support - use instead of toLocaleString
function formatNumberRTL(value, locale = 'en-US') {
  if (value === null || value === undefined) return value;

  const num = Number(value);
  if (isNaN(num)) return value;

  const isNegative = num < 0;
  const formatted = Math.abs(num).toLocaleString(locale);

  // Add LRM before minus sign for correct RTL display
  if (isNegative) {
    return "\u200E-" + formatted;
  }

  return formatted;
}

function reverseNumberFormatter(value) {
  if (!value) return value;

  const parts = value.toString().split('.');
  const numberPartWithComma = parts[0];
  let numberpart = numberPartWithComma.toString().split(',');
  const formattedValue = numberpart.join('');
  return Number(formattedValue);
}

function formatDate(date) {
  if (!date) return '';
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
}

export {
  isMobileDevice,
  formatDate,
  updateAppTitle,
  validateEmail,
  changeAppLanguage,
  checkAuthToken,
  isValidPasswordChar,
  removeAuthUserInfo,
  numberFormatter,
  reverseNumberFormatter,
  formatNumberRTL,
};